import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
 //     primary: '#344945',
 //     secondary: '#F3F5F6',
 //     accent: '#f9aa33',
 //     error: '#ff5722',
 //     warning: '#f44336',
 //     info: '#2196f3',
 //     success: '#e91e63'
 /* My custom colors */
        cGrey: "#757575",
        cDkGrey: "#616161"
      },
    },
  },
    options: { customProperties: true }
})

export default vuetify;
